<div
  data-test="b-ihZDyT"
  class="letter-image"
  *ngIf="showingLetters"
  [ngClass]="!color ? 'color-' + colorNumber : ''"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.font-size.px]="size"
  [style.background-color]="color"
>
  <span data-test="RqVY1V9k">{{ letters }}</span>
</div>
<div
  data-test="uiq1tuvc"
  class="badge badge_notification badge_notification-border"
  [ngClass]="!color ? 'color-' + colorNumber : ''"
  *ngIf="!!badge?.toString()?.length"
>
  {{ badge }}
</div>
